import { Radio } from '@apollo/orbit';
import React from 'react';

import {
  TimeRangeOption,
  printTimeRangeLabel,
} from 'src/lib/config/timeRangeOptions';

type Props = {
  className?: string;
  options: TimeRangeOption[];
};

export const DisabledOptionsSection = ({ className, options }: Props) => {
  return (
    <div className={className}>
      {options.map((option) => {
        return (
          <div
            key={option}
            className="-mx-2 flex items-center rounded px-2 py-1 text-secondary"
          >
            <Radio isChecked={false} isDisabled={true} />
            <span className="ml-2 flex-1 ">{printTimeRangeLabel(option)}</span>
          </div>
        );
      })}
    </div>
  );
};
